import '/vercel/path0/docs/demo/draggable.md?watch=parent';
export const toc = new Proxy([], {});
export const frontmatter = new Proxy({"title":"draggable","toc":"menu","filename":"docs/demo/draggable.md","lastUpdated":1780671434000,"nav":{"title":"Demo","path":"/demo"}}, {});

export const demoIndex = {
  ids: ["docs-demo-draggable-demo-draggable"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/vercel/path0/docs/demo/draggable.md?type=demo')
};